<script>
/**
 * 空状态
 * @type component
 * @title 空状态
 * @category 数据展示
 */
export default {
    name: 'VEmpty',
    functional: true,
    props: {
        /**
         * 图片地址
         * @title 图片地址
         */
        image: {
            type: String,
            default: 'default_common',
        },
        /**
         * 图片大小
         * @title 图片大小
         * @values small|medium|large
         */
        size: {
            type: String,
            // 设计同学统计最常用的为large档，small|medium适合窄边页面
            default: 'large',
        },
        /**
         * 标题内容
         * @title 标题内容
         */
        title: {
            type: String,
            default: '',
        },
        /**
         * 描述内容，支持字符串或数组（字符串和按钮对象组合）
         * @title 描述内容
         */
        desc: {
            type: [Array, String],
            default: '暂无数据',
        },
        /**
         * 按钮配置，支持单个按钮对象或按钮组
         * @title 按钮配置
         */
        button: {
            type: [Array, Object],
            default: () => [],
        },
    },

    data() {
        return {};
    },

    render(h, context) {
        const { props: { size, image, title, desc, button }, slots } = context;
        const slotsNodes = slots();
        const boxCls = `v-empty v-empty--${size}`;
        // 图片区
        const imageEl = slotsNodes.image || (image ? (
            <div class="v-empty__image">
                {/:|\/\//.test(image) ? <img class="image" src={image} /> : <v-icon name={image} remote />}
            </div>
        ) : null);
        // 标题区
        const titleEl = slotsNodes.title || (title ? <div class="v-empty__title"> {title}</div> : null);
        // 描述区
        const descList = Array.isArray(desc) ? desc : [desc];
        const descEl = slotsNodes.desc || slotsNodes.default || (descList.length ? (<div class="v-empty__desc">
            {descList.map(t => {
                if (typeof t === 'string') {
                    return t;
                }
                return <v-button {...{ attrs: t, on: { click: t.click } }} />;
            })}
        </div>) : null);
        // 按钮区
        const buttonList = Array.isArray(button) ? button : [button];
        const buttonEl = slotsNodes.button || (buttonList.length ? <v-button-group class="v-empty__button"> {
            buttonList.map(t => <v-button {...{ attrs: t, on: { click: t.click } }} />)
        }</v-button-group> : null);

        return (
            <div class={boxCls} >
                {imageEl}
                {titleEl}
                {descEl}
                {buttonEl}
            </div >
        );
    },
};
</script>

<style lang="less">
.v-empty {
    position: relative;
    width: 100%;
    height: 90%;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    -webkit-justify-content: center;
    -ms-flex-pack: center;
    justify-content: center;
    -webkit-align-items: center;
    -ms-flex-align: center;
    align-items: center;
    font-size: 14px;
    text-align: center;
    z-index: 1;
}

.v-empty .image {
    display: block
}

.v-empty__image {
    padding-bottom: 9px
}

.v-empty__title {
    font-size: 14px;
    line-height: 20px;
    font-weight: 500
}

.v-empty__desc,.v-empty__title {
    text-align: center;
    padding: 3px 0
}

.v-empty__desc {
    font-size: 12px;
    line-height: 16px
}

.v-empty__button {
    padding: 9px 0
}

.v-empty--small .image,.v-empty--small .v-icon {
    width: 70px;
    height: 70px
}

.v-empty--medium .image,.v-empty--medium .v-icon {
    width: 120px;
    height: 120px
}

.v-empty--large .image,.v-empty--large .v-icon {
    width: 160px;
    height: 160px
}
</style>
